export default class LocationsModel extends Backbone.Model {
  constructor(options) {
    super(options);
  }
}
